import React from 'react';

const mergedGif = process.env.PUBLIC_URL + '/assets/lp-full-2.gif';

const VideoRedactionAnimation = () => {
  return (
    <div className="relative w-full h-full">
      {/* Glow effect behind */}
      <div className="absolute inset-0 blur-3xl bg-[#9DC45F]/10 animate-pulse" />

      {/* Main container with gradient border */}
      <div className="relative w-full h-full rounded-xl overflow-hidden p-[2px] bg-gradient-to-r from-[#9DC45F]/30 via-[#7A9F3E]/30 to-[#9DC45F]/30 animate-gradient">
        <div className="relative w-full h-full bg-white rounded-xl overflow-hidden">
          {/* Video - no effects applied here */}
          <img
            src={mergedGif}
            alt="AI Video Redaction Process"
            className="w-full h-full object-cover"
          />

          {/* Border vignette - only on edges */}
          <div className="absolute inset-0 pointer-events-none">
            {/* Left edge */}
            <div className="absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-black/20 to-transparent blur-sm" />

            {/* Right edge */}
            <div className="absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-black/20 to-transparent blur-sm" />

            {/* Top edge */}
            <div className="absolute top-0 left-0 right-0 h-16 bg-gradient-to-b from-black/20 to-transparent blur-sm" />

            {/* Bottom edge */}
            <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-black/20 to-transparent blur-sm" />
          </div>

          {/* Corner accents */}
          <div className="absolute top-0 left-0 w-8 h-8 border-t-2 border-l-2 border-[#9DC45F]/40 rounded-tl-xl" />
          <div className="absolute top-0 right-0 w-8 h-8 border-t-2 border-r-2 border-[#9DC45F]/40 rounded-tr-xl" />
          <div className="absolute bottom-0 left-0 w-8 h-8 border-b-2 border-l-2 border-[#9DC45F]/40 rounded-bl-xl" />
          <div className="absolute bottom-0 right-0 w-8 h-8 border-b-2 border-r-2 border-[#9DC45F]/40 rounded-br-xl" />
        </div>
      </div>

      <style jsx>{`
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }

        .animate-gradient {
          background-size: 200% 200%;
          animation: gradient 8s ease infinite;
        }
      `}</style>
    </div>
  );
};

export default VideoRedactionAnimation;